import { render, staticRenderFns } from "./ResponseType2.vue?vue&type=template&id=f00e5710&scoped=true"
import script from "./ResponseType2.vue?vue&type=script&lang=js"
export * from "./ResponseType2.vue?vue&type=script&lang=js"
import style0 from "./ResponseType2.vue?vue&type=style&index=0&id=f00e5710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00e5710",
  null
  
)

export default component.exports